/* eslint no-underscore-dangle: ["error", { "allow": ["_id"]}] */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SortMark from '../Parts/SortMark';
import Checkbox from '../Parts/Checkbox';
import UserIcon from '../Parts/UserIcon';
import chevronRightIcon from '../../images/common/chevron_right.svg';
import {
  MAX_REMOTE_OPPOSITE_NUM,
  REMOTE_SUPPORT_STATUS,
} from '../../lib/constants';
import { isGuest } from '../../lib/tools';
import {
  Main,
  Table,
  ThTable,
  Thead,
  TheadTr,
  Tbody,
  TbodyTr,
  ThCheckbox,
  TdCheckbox,
  ThOperatorName,
  TdOperatorName,
  ScrolledBody,
  SortWrapper,
  OperatorNameWrapper,
  OperatorName,
  ChevronImage,
} from './styles/OperatorListsStyles';

const OperatorLists = ({
  operators,
  onSelect,
  onChangeSort,
  searchOptions,
  onCheck,
  remoteMembers,
  onAllCheck,
  userInfo,
  innerRole,
  namePartial,
}) => {
  const isGuestUser = isGuest(innerRole);
  const { sort } = searchOptions;
  const sortOrder = sort === 'asc' ? 'A' : 'D';

  const enabledCheck = MAX_REMOTE_OPPOSITE_NUM > remoteMembers.length;
  // 名称での絞り込み
  const searchOperators = operators.filter(({ name }) =>
    name.toLowerCase().includes(namePartial.toLowerCase()),
  );
  // チェックボックス表示対象
  const targetOperators = searchOperators.filter(
    ({ operatorId }) => operatorId !== userInfo.operatorId,
  );
  // チェック済チェックボックス数
  const checkedTargetCount = targetOperators.filter(operator =>
    remoteMembers.some(({ operatorId }) => operatorId === operator.operatorId),
  ).length;
  // 表示されているチェックボックス数が、チェック可能数以内の場合は全チェックボックスを表示する
  const showAllCheckbox =
    targetOperators.length > 0 &&
    remoteMembers.length - checkedTargetCount + targetOperators.length <=
      MAX_REMOTE_OPPOSITE_NUM;
  return (
    <Main className="OperatorListsts">
      <ThTable>
        <Thead>
          <TheadTr>
            <ThCheckbox>
              {userInfo.operatorLicenseInfo.isRemoteOperatorEnabled &&
                showAllCheckbox && (
                  <Checkbox
                    checkboxKey="ds-operators-all"
                    checked={targetOperators.length === checkedTargetCount}
                    onCheck={onAllCheck}
                  />
                )}
            </ThCheckbox>
            <ThOperatorName>
              <SortWrapper
                className="clickableItem"
                id="operatorOperatorNameSortMarkClick"
                role="presentation"
                onClick={() => onChangeSort()}
              >
                <FormattedMessage id="operator.dashboard.operators.title" />
                <SortMark sort={sort} order={sortOrder} />
              </SortWrapper>
            </ThOperatorName>
          </TheadTr>
        </Thead>
      </ThTable>
      <ScrolledBody>
        <Table>
          <Tbody>
            {searchOperators &&
              searchOperators.map((list, idx) => {
                const onClickOperator = `onClickOperator${idx}`;
                const checked = remoteMembers.some(
                  ({ operatorId }) => operatorId === list.operatorId,
                );
                return (
                  <TbodyTr
                    className="clickableItem"
                    id={onClickOperator}
                    key={onClickOperator}
                    clickable={!isGuestUser}
                    checked={checked}
                    onClick={() =>
                      (!isGuestUser && onSelect(list.operatorId)) || undefined
                    }
                  >
                    <TdCheckbox>
                      {userInfo.operatorLicenseInfo.isRemoteOperatorEnabled &&
                        userInfo.operatorId !== list.operatorId &&
                        list.remoteSupportStatus ===
                          REMOTE_SUPPORT_STATUS.enable && (
                          <Checkbox
                            disabled={!checked && !enabledCheck}
                            checkboxKey={`ds-operators-${idx}`}
                            checked={checked}
                            onCheck={() => onCheck(list.operatorId)}
                          />
                        )}
                    </TdCheckbox>
                    <TdOperatorName>
                      <OperatorNameWrapper>
                        <UserIcon url={list.iconUrl} />
                        <OperatorName>{list.name || ''}</OperatorName>
                        {!isGuestUser && (
                          <ChevronImage
                            src={chevronRightIcon}
                            alt={list.name}
                          />
                        )}
                      </OperatorNameWrapper>
                    </TdOperatorName>
                  </TbodyTr>
                );
              })}
          </Tbody>
        </Table>
      </ScrolledBody>
    </Main>
  );
};

OperatorLists.propTypes = {
  operators: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onChangeSort: PropTypes.func.isRequired,
  searchOptions: PropTypes.object.isRequired,
  onCheck: PropTypes.func.isRequired,
  remoteMembers: PropTypes.array.isRequired,
  onAllCheck: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  innerRole: PropTypes.number.isRequired,
  namePartial: PropTypes.string.isRequired,
};

export default OperatorLists;
